import DesignServicesVistaprintProxyService from 'services/DesignServicesVistaprintProxyService';

export default class DesignServicesService {
    constructor(host) {
        this.host = host;

        this.submitCoDesignOrder = this.submitCoDesignOrder.bind(this);
        this.submitDifyOrder = this.submitDifyOrder.bind(this);
        this.saveDifyOrder = this.saveDifyOrder.bind(this);
        this.submitUploadGoRequest = this.submitUploadGoRequest.bind(this);
    }

    async submitCoDesignOrder(payload) {
        const endpoint = 'DesignServiceOrder/Codesign/Submit';
        const response = await DesignServicesVistaprintProxyService.post(this.host, endpoint, payload);

        if (!response.ok) {
            if (response.status === 409) {
                throw new Error('Appointment unavailable'); // already booked
            } else {
                throw new Error(`${response.status} - ${response.statusText}`);
            }
        }
    }

    async submitDifyOrder(payload) {
        const endpoint = 'NewDesignServiceOrder/Submit';
        const response = await DesignServicesVistaprintProxyService.post(this.host, endpoint, payload);

        if (!response.ok) {
            throw new Error(`${response.status} - ${response.statusText}`);
        }
    }

    async saveDifyOrder(payload) {
        const endpoint = 'DesignServiceOrder/Update';
        const response = await DesignServicesVistaprintProxyService.post(this.host, endpoint, payload);

        if (!response.ok) {
            throw new Error(`${response.status} - ${response.statusText}`);
        }
    }

    async submitUploadGoRequest({uploadIds, note, templateId, documentId}) {
        const uri = '/DesignServices/api/TemplateEdits/PostOrder';
        return await fetch(uri, {
            method: 'POST',
            credentials: 'include', // send credential cookie with request
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                "UploadIds": uploadIds,
                "Comment": note,
                "TemplateId": templateId,
                "DocumentId": documentId,
                "PhoneNumber": "",
                "BriefVersion": 1
            })
        });

    }
}



// WEBPACK FOOTER //
// ./src/services/designServices/DesignServicesService.js